import { scrollTo } from '@utils/common';
import { findRangesFromNotes } from './findRangesFromNotes.js';

// Expose whether or not we're scrolling to a note. This is used to ensure that
// scroll-anchor-into-view.ts does not take over scrolling when we're supposed
// to navigate to a note.
let isScrollingToNote = false;

/**
 * apply highlighting of all notes on the current page.
 */
async function highlightNotesOnPage(notes, backlinkContext, onScrollViaBacklink) {
  // first of all, identify all existing notes within the page
  const existingNotes = document.querySelectorAll(`mark.${markCls}`);

  // then iterate over the list of notes on the page and inject them
  // afresh
  const noteRanges = findRangesFromNotes(notes);
  for (let result = await noteRanges.next(); !result.done; result = await noteRanges.next()) {
    const {
      note,
      ranges
    } = result.value;
    for (const range of ranges) {
      const highlightNode = document.createElement("mark");
      highlightNode.className = markCls;
      const targetedViaBacklink = JSON.stringify(note.context) === JSON.stringify(backlinkContext);

      // open the notebook on click on the highlight item
      highlightNode.addEventListener("click", () => {
        gNotebook?.requestOpen({
          noteId: note.objectID
        });
      });
      range.surroundContents(highlightNode);
      if (targetedViaBacklink) {
        isScrollingToNote = true;
        const bbox = highlightNode.getBoundingClientRect();
        scrollTo(window.scrollY + bbox.top + bbox.height / 2 - window.innerHeight / 2, {
          forceAutoScroll: true,
          disableMaxScroll: true
        });
        onScrollViaBacklink();
        setTimeout(() => {
          isScrollingToNote = false;
        }, 200);
      }
    }
  }

  // and once we're done applying new note highlights, iterate through the old
  // ones and remove them
  const contentRange = document.createRange();
  existingNotes.forEach(existingHighlight => {
    contentRange.selectNodeContents(existingHighlight);
    existingHighlight.parentNode?.insertBefore(contentRange.extractContents(), existingHighlight);
    existingHighlight.parentNode?.removeChild(existingHighlight);
  });
}
const markCls = "_61m1pydw14";

export { highlightNotesOnPage, isScrollingToNote };
import "./highlightNotesOnPage.linaria.module.css";
//# sourceMappingURL=highlightNotesOnPage.js.map
